import { render, staticRenderFns } from "./activeSwitcherIcon.vue?vue&type=template&id=42af5af2&"
import script from "./activeSwitcherIcon.vue?vue&type=script&lang=js&"
export * from "./activeSwitcherIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports